import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'Navigation',
  setup(__props) {

const REDIRECTION_URL = window.location.href;

return (_ctx: any,_cache: any) => {
  const _component_snap_logo = _resolveComponent("snap-logo")!
  const _component_snap_header_wrapper = _resolveComponent("snap-header-wrapper")!
  const _component_snap_global_header = _resolveComponent("snap-global-header")!

  return (_openBlock(), _createBlock(_component_snap_global_header, { theme: "store" }, {
    default: _withCtx(() => [
      _createElementVNode("span", null, [
        _createVNode(_component_snap_logo, {
          product: "snap-logo-store",
          white: "true",
          variant: "1line"
        })
      ]),
      _createVNode(_component_snap_header_wrapper, {
        "redirect-on-signout": _unref(REDIRECTION_URL),
        "show-app-switcher": "true",
        "show-login-buttons": "false"
      }, null, 8, ["redirect-on-signout"])
    ]),
    _: 1
  }))
}
}

})